import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';

import { useState, useRef, useEffect } from 'react';
import { useCallback } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundThumbUp from '@iconify/icons-ic/round-thumb-up';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import moreHorizontalFill from '@iconify/icons-eva/more-horizontal-fill';
// material
import test_dark from '../../../../src/components/test_dark.svg'
import { MobileDateRangePicker, LoadingButton } from '@material-ui/lab';
import { styled } from '@material-ui/core/styles';
import {
    Box,
    Stack,
    Drawer,
    Button,
    Avatar,
    Tooltip,
    Divider,
    MenuItem,
    TextField,
    Typography,
    OutlinedInput,
    Grid,
    Card,
    Tabs,
    Tab,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
//

import { MIconButton, MHidden } from '../../../components/@material-extend';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
import useAuth from '../../../hooks/useAuth'
import { objectID } from '../../../utils/objectID';
import { useSelector } from 'react-redux';

import { capitalCase } from 'change-case';
import Scrollbar from '../../../components/Scrollbar';
import FileUpload from "react-mui-fileuploader";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useHref } from 'react-router-dom';
const PRIORITIZES = ['low', 'medium', 'hight'];

FUpload.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    card: PropTypes.object,
    onDeleteTask: PropTypes.func
};

const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    width: 140,
    fontSize: 13,
    flexShrink: 0,
    color: theme.palette.text.secondary
}));

// ----------------------------------------------------------------------

export default function FUpload({ isOpen, onClose, formik, isReadOnly }) {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const [filesToUpload, setFilesToUpload] = useState([]);
    const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;
    const handleFilesChange = (files) => {
        // Update chosen files
       // setFilesToUpload([...files]);
        setFieldValue('file_ticket',...files);
    };
    return (
        <>
            <FileUpload
                disabled={isReadOnly}
                title=""
                header="Kéo thả file vào đây!!"
                leftLabel='hoặc'
                buttonLabel='Nhấp vào đây'
                rightLabel='để chọn file!!'
                imageSrc={test_dark}
                maxUploadFiles={1}
                multiFile={false}
                onFilesChange={handleFilesChange}
                onContextReady={(context) => { }}
                containerProps={{ sx: { p: 2 } }}
                BannerProps={{ sx: { mt: 2, px: 1, backgroundColor: "#303187" } }}
                PlaceholderImageDimension={{ width: 150, height: 150,}}

            />
        </>
    );
}
